export default __webpack_public_path__ + "Timeisup_7Seconds.22a482.mp3";